export default __webpack_public_path__ + "static/media/April_00.74d7e7d8.png";